import React from "react";
import "./ai.css";

import {
  MapPin,
  ShieldAlert,
  AlertTriangle,
  Smartphone,
  Download
} from "lucide-react";

export default function AISecurityDashboard() {
  return (
    <div className="ai-content">
      {/* Stats Cards */}
      <div className="cards">
        <Card
          title="Risk Score"
          value="78"
          suffix="/100"
          extra="↑ 12% from last 7 days"
          badge="High Risk"
          badgeType="danger"
        />

        <Card
          title="Tamper Confidence"
          value="92%"
          extra="Low Tampering Likelihood"
          progress={92}
        />

        <Card
          title="Trust Score"
          value="85"
          suffix="/100"
          extra="↑ 8% from last 7 days"
          badge="Trusted"
          badgeType="success"
        />

        <Card
          title="Anomaly Detection"
          value="14"
          extra="↑ 3 new anomalies"
        />
      </div>

      {/* Middle Grid */}
      <div className="ai-grid">
        {/* Trend Chart */}
        <div className="panel">
          <div className="panel-header">
            <span className="panel-title">
              Risk Score Trend
            </span>

            <select className="mini-select">
              <option>Last 7 Days</option>
            </select>
          </div>

          <div className="line-chart">
  <svg viewBox="0 0 720 380" preserveAspectRatio="xMidYMid meet">

    {/* Horizontal Grid Lines */}
    <line x1="60" y1="20" x2="700" y2="20" className="grid-line" />
    <line x1="60" y1="90" x2="700" y2="90" className="grid-line" />
    <line x1="60" y1="160" x2="700" y2="160" className="grid-line" />
    <line x1="60" y1="230" x2="700" y2="230" className="grid-line" />
    <line x1="60" y1="300" x2="700" y2="300" className="grid-line" />

    {/* Y Axis Labels */}
    <text x="8" y="25" className="axis-label">100</text>
    <text x="15" y="95" className="axis-label">75</text>
    <text x="15" y="165" className="axis-label">50</text>
    <text x="15" y="235" className="axis-label">25</text>
    <text x="22" y="305" className="axis-label">0</text>

    {/* Area Fill */}
    <path
      d="M80 220 L180 133 L280 112 L380 168 L480 105 L580 154 L680 84 L680 300 L80 300 Z"
      fill="rgba(59,130,246,0.08)"
    />

    {/* Trend Line */}
    <polyline
      fill="none"
      stroke="#2563eb"
      strokeWidth="3"
      strokeLinejoin="round"
      strokeLinecap="round"
      points="80,220 180,133 280,112 380,168 480,105 580,154 680,84"
    />

    {/* Dots */}
    <circle cx="80" cy="220" r="5" className="chart-dot" />
    <circle cx="180" cy="133" r="5" className="chart-dot" />
    <circle cx="280" cy="112" r="5" className="chart-dot" />
    <circle cx="380" cy="168" r="5" className="chart-dot" />
    <circle cx="480" cy="105" r="5" className="chart-dot" />
    <circle cx="580" cy="154" r="5" className="chart-dot" />
    <circle cx="680" cy="84" r="5" className="chart-dot" />

    {/* X Axis Labels */}
    <text x="55" y="335" className="axis-label">May 9</text>
    <text x="148" y="335" className="axis-label">May 10</text>
    <text x="248" y="335" className="axis-label">May 11</text>
    <text x="348" y="335" className="axis-label">May 12</text>
    <text x="448" y="335" className="axis-label">May 13</text>
    <text x="548" y="335" className="axis-label">May 14</text>
    <text x="648" y="335" className="axis-label">May 15</text>

  </svg>
</div>
</div>

        {/* Heatmap */}
        <div className="panel">
  <div className="panel-title">
    Anomaly Heatmap
  </div>

  <div className="heatmap">

    <img
      src="/world-map-light.png"
      alt="World Map"
      className="map-image"
    />

    {/* USA Hotspot */}
    <div className="hotspot hotspot-red"></div>

    {/* Asia Hotspot */}
    <div className="hotspot hotspot-orange"></div>

    {/* South America Hotspot */}
    <div className="hotspot hotspot-green"></div>

    <div className="heat-legend">
      <span>High</span>

      <div className="legend-bar"></div>

      <span>Low</span>
    </div>

  </div>
        </div>

        {/* Suspicious Activity */}
        <div className="panel">
  <div className="panel-title">
    Suspicious Behavior Detection
  </div>

  <Event
    icon={<MapPin size={18} />}
    title="Unusual Access Location"
    count="2 Events"
    danger
  />

  <Event
    icon={<ShieldAlert size={18} />}
    title="Multiple Failed Verifications"
    count="5 Events"
  />

  <Event
    icon={<AlertTriangle size={18} />}
    title="Abnormal Signing Pattern"
    count="3 Events"
  />

  <Event
    icon={<Smartphone size={18} />}
    title="Untrusted Device Access"
    count="1 Event"
  />

  <Event
    icon={<Download size={18} />}
    title="Mass Download Attempt"
    count="2 Events"
    danger
  />
</div>
</div>

      {/* Table */}
<div className="table-wrapper">

  <div className="table-title">
    Recent AI Detections
  </div>

  <table className="ai-table">
    <thead>
      <tr>
        <th>Event</th>
        <th>Risk Level</th>
        <th>Confidence</th>
        <th>Description</th>
        <th>Detected On</th>
        <th>Status</th>
      </tr>
    </thead>

    <tbody>

      <Row
        icon={<MapPin size={16} />}
        e="Unusual Access Location"
        r="High"
        c="92%"
        d="Access from new geolocation (Russia)"
        date="May 15, 2024 10:25 AM"
        status="Investigating"
      />

      <Row
        icon={<AlertTriangle size={16} />}
        e="Abnormal Signing Pattern"
        r="Medium"
        c="78%"
        d="Signing frequency deviates from baseline"
        date="May 15, 2024 09:47 AM"
        status="Open"
      />

      <Row
        icon={<ShieldAlert size={16} />}
        e="Multiple Failed Verifications"
        r="High"
        c="88%"
        d="Multiple documents failed verification"
        date="May 14, 2024 11:12 PM"
        status="Investigating"
      />

      <Row
        icon={<Smartphone size={16} />}
        e="Untrusted Device Access"
        r="Medium"
        c="65%"
        d="Access from untrusted device fingerprint"
        date="May 14, 2024 08:33 PM"
        status="Open"
      />

    </tbody>
  </table>

</div>
    </div>
  );
}

/* Card */
function Card({
  title,
  value,
  suffix,
  extra,
  badge,
  badgeType,
  progress
}) {
  return (
    <div className="card">
      <div className="card-title">{title}</div>

      <div className="card-value-row">
        <div className="card-value">
          {value}
          {suffix && <span className="card-suffix">{suffix}</span>}
        </div>
        {badge && (
          <span className={`status-badge ${badgeType}`}>{badge}</span>
        )}
      </div>

      <div className="card-extra">{extra}</div>

      {progress && (
        <div className="progress">
          <div className="progress-fill" style={{ width: `${progress}%` }}></div>
        </div>
      )}
    </div>
  );
}

/* Event */
function Event({
  icon,
  title,
  count,
  danger
}) {
  return (
    <div className="suspicious-item">
      <div className="event-left">
        <span
          className={
            danger
              ? "event-icon danger-icon"
              : "event-icon warning-icon"
          }
        >
          {icon}
        </span>

        <span className="event-title">
          {title}
        </span>
      </div>

      <span className="event-total">
        {count}
      </span>
    </div>
  );
}

/* Table Row */
function Row({
  icon,
  e,
  r,
  c,
  d,
  date,
  status
}) {
  return (
    <tr>

      <td>
        <div className="event-cell">
          <span className={`table-icon ${r === "High" ? "table-icon-high" : "table-icon-medium"}`}>
            {icon}
          </span>
          <span>{e}</span>
        </div>
      </td>

      <td>
        <span
          className={
            r === "High"
              ? "risk-high"
              : "risk-medium"
          }
        >
          {r}
        </span>
      </td>

      <td>{c}</td>

      <td>{d}</td>

      <td>{date}</td>

      <td>
        <span
          className={
            status === "Investigating"
              ? "status-investigating"
              : "status-open"
          }
        >
          {status}
        </span>
      </td>

    </tr>
  );
}